export default {
  name: 'need-module',

  ui: {
    'nextStep[]': '[js-need-module-next]',
    progress: '[js-need-module-progress]',
    progressTxt: '[js-need-module-progress-txt]',
    progressTxtWrap: '[js-need-module-progress-txt-wrap]',
    results: '[js-need-module-results]',
    close: '[js-need-module-close]',
  },

  currentStep: -1,
  results: [],

  events: [
    {
      on: 'click',
      target: 'nextStep',
      handle(e) {
        // get current answer
        if (this.currentStep >= 0) {
          
          this.results.push(document.querySelector('[js-need-module-step].is-active .swiper-slide-active p').dataset.slug)
        }

        document.querySelector('[js-need-module-step].is-active').classList.remove('is-active')
        document.querySelector(`[js-need-module-step][data-step='${e.target.dataset.step}']`).classList.add('is-active')
        this.currentStep = this.currentStep + 1

        const percent = this.currentStep / parseInt(this.props.totalStep)
        this.ui.progress.style.transform = `scaleY(${percent})`
        this.ui.progressTxtWrap.style.top = `${percent * 100}%`
        this.ui.progressTxt.innerHTML = parseInt(percent * 100)
        this.manageTracking()

        if (this.currentStep === 1) {
          this.ui.progressTxtWrap.classList.add('is-visible')
        }
      },
    },
    {
      on: 'click',
      target: 'results',
      handle(e) {
        //  last question answer
        this.results.push(document.querySelector('[js-need-module-step].is-active .swiper-slide-active p').dataset.slug)
        this.manageTracking(true)

        let models, versions, model, version

        if (this.props.site === 'sailing') {
          models = {
            500: {
              thermal: 'Isla 40',
              hybrid: 'Astrea 42',
            },
            '500-600': {
              thermal: 'Astrea 42',
              hybrid: 'Astrea 42',
            },
            '700-800': {
              thermal: 'Elba 45',
              hybrid: 'Elba 45',
            },
            '800-1': {
              thermal: 'Tanna 47',
              hybrid: 'Elba 45',
            },
            '1-2': {
              thermal: 'Aura 51',
              hybrid: 'Aura 51',
            },
            '2-3': {
              thermal: 'Samana 59',
              hybrid: 'Aura 51',
            },
            '3-4': {
              thermal: 'Alegria 67',
              hybrid: 'Aura 51',
            },
            4: {
              thermal: 'Thira 80',
              hybrid: 'Aura 51',
            },
          }

          versions = {
            'Isla 40': {
              3: ['Maestro 2 Sdb', 'Maestro', 'Maestro', 'Maestro', 'Maestro'],
              4: ['Quatuor 2 Sdb', 'Quatuor', 'Quatuor', 'Quatuor', 'Quatuor'],
              5: ['Quatuor 2 Sdb', 'Quatuor', 'Quatuor', 'Quatuor', 'Quatuor'],
              6: ['Quatuor 2 Sdb', 'Quatuor', 'Quatuor', 'Quatuor', 'Quatuor'],
            },
            'Astrea 42': {
              3: ['Maestro', 'Maestro', 'Maestro', 'Maestro', 'Maestro'],
              4: ['Quatuor', 'Quatuor', 'Quatuor', 'Quatuor', 'Quatuor'],
              5: ['Quatuor', 'Quatuor', 'Quatuor', 'Quatuor', 'Quatuor'],
              6: ['Quatuor', 'Quatuor', 'Quatuor', 'Quatuor', 'Quatuor'],
            },
            'Elba 45': {
              3: ['Maestro', 'Maestro', 'Maestro', 'Maestro', 'Maestro'],
              4: ['Quatuor', 'Quatuor', 'Quatuor', 'Quatuor', 'Quatuor'],
              5: ['Quatuor', 'Quatuor', 'Quatuor', 'Quatuor', 'Quatuor'],
              6: ['Quatuor', 'Quatuor', 'Quatuor', 'Quatuor', 'Quatuor'],
            },
            'Tanna 47': {
              3: ['Maestro', 'Maestro', 'Maestro', 'Maestro', 'Maestro'],
              4: ['Quintet', 'Quintet', 'Quintet', 'Quintet', 'Quintet'],
              5: ['Quintet', 'Quintet', 'Quintet', 'Quintet', 'Quintet'],
              6: ['Quintet', 'Quintet', 'Quintet', 'Quintet', 'Quintet'],
            },
            'Aura 51': {
              3: ['Double Maestro', 'Double Maestro', 'Double Maestro', 'Double Maestro', 'Double Maestro'],
              4: ['Double Maestro', 'Double Maestro', 'Double Maestro', 'Double Maestro', 'Double Maestro'],
              5: ['Maestro 5 cabines', 'Maestro 5 cabines', 'Maestro 5 cabines', 'Maestro 5 cabines', 'Maestro 5 cabines'],
              6: ['6 cabines', '6 cabines', '6 cabines', '6 cabines', '6 cabines'],
            },
            'Samana 59': {
              3: ['Lounge Maestro (cuisine en bas)', 'Lounge Maestro (cuisine en bas)', 'Lounge Maestro (cuisine en bas)', 'Lounge Maestro (cuisine en bas)', 'Lounge Maestro (cuisine en bas)'],
              4: ['Lounge Maestro (cuisine en bas)', 'Lounge Maestro (cuisine en bas)', 'Lounge Maestro (cuisine en bas)', 'Lounge Maestro (cuisine en bas)', 'Lounge Maestro (cuisine en bas)'],
              5: ['Charter 6 cabines (cuisine en haut)', 'Charter 6 cabines (cuisine en haut)', 'Charter 6 cabines (cuisine en haut)', 'Charter 6 cabines (cuisine en haut)', 'Charter 6 cabines (cuisine en haut)'],
              6: ['Charter 6 cabines (cuisine en haut)', 'Charter 6 cabines (cuisine en haut)', 'Charter 6 cabines (cuisine en haut)', 'Charter 6 cabines (cuisine en haut)', 'Charter 6 cabines (cuisine en haut)'],
            },
            'Alegria 67': {
              3: ['Lounge Maestro (cuisine en Bas)', 'Lounge Maestro (cuisine en Bas)', 'Lounge Maestro (cuisine en Bas)', 'Lounge Maestro (cuisine en Bas)', 'Lounge Maestro (cuisine en Bas)'],
              4: ['Lounge Maestro (cuisine en Bas)', 'Lounge Maestro (cuisine en Bas)', 'Lounge Maestro (cuisine en Bas)', 'Lounge Maestro (cuisine en Bas)', 'Lounge Maestro (cuisine en Bas)'],
              5: ['Maestro (cuisine en haut)', 'Maestro (cuisine en haut)', 'Maestro (cuisine en haut)', 'Maestro (cuisine en haut)', 'Maestro (cuisine en haut)'],
              6: ['6 cabines (cuisine en haut)', '6 cabines (cuisine en haut)', '6 cabines (cuisine en haut)', '6 cabines (cuisine en haut)', '6 cabines (cuisine en haut)'],
            },
            'Thira 80': {
              3: ['Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)'],
              4: ['Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)'],
              5: ['Maestro (Cuisine en haut)', 'Maestro (Cuisine en haut)', 'Maestro (Cuisine en haut)', 'Maestro (Cuisine en haut)', 'Maestro (Cuisine en haut)'],
              6: ['VIP 6 cabines', 'VIP 6 cabines', 'VIP 6 cabines', 'VIP 6 cabines', 'VIP 6 cabines'],
            },
          }

          model = models[this.results[7]][this.results[6]]
          version = versions[model][this.results[4]][parseInt(this.results[5]) - 2]
        } else {
          models = {
            500: 'MY4.S',
            '700-900': 'MY5',
            '900-2': 'MY6',
            '3-4': 'Power 67',
            4: 'Power 80',
          }

          versions = {
            'MY4.S': {
              3: ['Maestro', 'Maestro', 'Maestro', 'Maestro', 'Maestro'],
              4: ['Quatuor', 'Quatuor', 'Quatuor', 'Quatuor', 'Quatuor'],
              5: ['Quatuor', 'Quatuor', 'Quatuor', 'Quatuor', 'Quatuor'],
              6: ['Quatuor', 'Quatuor', 'Quatuor', 'Quatuor', 'Quatuor'],
            },
            MY5: {
              3: ['Maestro', 'Maestro', 'Maestro', 'Maestro', 'Maestro'],
              4: ['Maestro', 'Maestro', 'Maestro', 'Maestro', 'Maestro'],
              5: ['Maestro', 'Maestro', 'Maestro', 'Maestro', 'Maestro'],
              6: ['Maestro', 'Maestro', 'Maestro', 'Maestro', 'Maestro'],
            },
            MY6: {
              3: ['Maestro', 'Maestro', 'Maestro', 'Maestro', 'Maestro'],
              4: ['Maestro', 'Maestro', 'Maestro', 'Maestro', 'Maestro'],
              5: ['Maestro', 'Maestro', 'Maestro', 'Maestro', 'Maestro'],
              6: ['Maestro', 'Maestro', 'Maestro', 'Maestro', 'Maestro'],
            },
            'Power 67': {
              3: ['Maestro Lounge (cuisine en bas)', 'Maestro Lounge (cuisine en bas)', 'Maestro Lounge (cuisine en bas)', 'Maestro Lounge (cuisine en bas)', 'Maestro Lounge (cuisine en bas)'],
              4: ['Maestro Lounge (cuisine en bas)', 'Maestro Lounge (cuisine en bas)', 'Maestro Lounge (cuisine en bas)', 'Maestro Lounge (cuisine en bas)', 'Maestro Lounge (cuisine en bas)'],
              5: ['Maestro (cuisine en haut)', 'Maestro (cuisine en haut)', 'Maestro (cuisine en haut)', 'Maestro (cuisine en haut)', 'Maestro (cuisine en haut)'],
              6: ['Maestro (cuisine en haut)', 'Maestro (cuisine en haut)', 'Maestro (cuisine en haut)', 'Maestro (cuisine en haut)', 'Maestro (cuisine en haut)'],
            },
            'Power 80': {
              3: ['Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)'],
              4: ['Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)', 'Maestro (Cuisine en bas)', 'Version Maestro (Cuisine en bas)'],
              5: ['Maestro (Cuisine en haut)', 'Maestro (Cuisine en haut)', 'Maestro (Cuisine en haut)', 'Maestro (Cuisine en haut)', 'Maestro (Cuisine en haut)'],
              6: ['VIP 6 cabines', 'VIP 6 cabines', 'VIP 6 cabines', 'VIP 6 cabines', 'VIP 6 cabines'],
            },
          }

          model = models[this.results[4]]
          version = versions[model][this.results[2]][parseInt(this.results[3]) - 2]
        }

        window.location = `${this.props.urlResults}?model=${model}&version=${version}`
      },
    },
    {
      on: 'click',
      target: 'close',
      handle(e) {
        this.results = []
        this.currentStep = -1
        this.ui.progressTxtWrap.classList.remove('is-visible')
        this.ui.progress.style.transform = 'scaleY(0)'
        this.ui.progressTxtWrap.style.top = '0'
        document.querySelector('[js-need-module-step].is-active').classList.remove('is-active')
        document.querySelector('[js-need-module-step][data-step="1"]').classList.add('is-active')

        this.el.querySelectorAll('[js-slider-reset]').forEach(reset => {
          reset.click()
        })
      },
    },
  ],

  manageTracking(isLastStep = false) {
    const isSailingSite= this.props.site && this.props.site == "sailing" ? true: false

    if (isLastStep) {

      if (isSailingSite) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'module-8-budget' });
        window.dataLayer.push({ 'event': 'module-9-resultat' });
      }
      else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'module-5-budget' });
        window.dataLayer.push({ 'event': 'module-6-resultat' });
      }
    }
    else {
      if (this.currentStep) {
        let curStep = this.currentStep

        if (isSailingSite) {
          if (curStep == 1) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'module-1-connaissance' });
          }
          else if (curStep == 2) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'module-2-programme' });
          }
          else if (curStep == 3) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'module-3-utilisation' });
          }
          else if (curStep == 4) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'module-4-equipage' });
          }
          else if (curStep == 5) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'module-5-cabine' });
          }
          else if (curStep == 6) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'module-6-sdb' });
          }
          else if (curStep == 7) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'module-7-propulsion' });
          }
        }
        else {
          if (curStep == 1) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'module-1-navigation' });
          }
          else if (curStep == 2) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'module-2-style' });
          }
          else if (curStep == 3) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'module-3-cabines' });
          }
          else if (curStep == 4) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'module-4-sdb' });
          }
        }
      }
    }
  },

  componentDidMount() {
  },
}
